import { render, staticRenderFns } from "./nopms.vue?vue&type=template&id=4c4c412d"
import script from "./nopms.vue?vue&type=script&lang=js"
export * from "./nopms.vue?vue&type=script&lang=js"
import style0 from "./nopms.vue?vue&type=style&index=0&id=4c4c412d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports